import { render } from "./UserInputButton.vue?vue&type=template&id=24d4332e&scoped=true"
import script from "./UserInputButton.vue?vue&type=script&lang=js"
export * from "./UserInputButton.vue?vue&type=script&lang=js"

import "./UserInputButton.vue?vue&type=style&index=0&id=24d4332e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d4332e"]])

export default __exports__